import { useMemo } from "react";
import { FireplaceDao } from "./FireplaceDao";

export const useFireplaceDao = (environment: string): FireplaceDao => {
  //const accessToken = useAccessToken();

  return useMemo(() => new FireplaceDao(environment), [environment]);
};
